import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

api.interceptors.request.use((c) => {
  const t = localStorage.getItem("fv_token");
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

export const fileUrl = (u) => (!u ? "" : u.startsWith("/api") ? `${BACKEND}${u}` : u);

export const waLink = (num, text) =>
  `https://wa.me/${(num || "").replace(/\D/g, "")}?text=${encodeURIComponent(text)}`;

export const CATEGORIES = [
  { value: "animales", label: "Animales" },
  { value: "exposiciones", label: "Exposiciones" },
  { value: "convenios", label: "Convenios" },
];

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Ocurrió un error. Intente de nuevo.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export const fmtDate = (iso) =>
  iso ? new Date(iso).toLocaleDateString("es-AR", { day: "numeric", month: "long", year: "numeric" }) : "";
